import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router';

const setParam = (base, name, value) => {

  const params = new URLSearchParams(base);

  params.delete(name);

  if (value) {
    params.append(name, value);
  }

  return params;
};

const useParam = (param) => {

  const [ params, setParams ] = useSearchParams();

  const value = params.get(param);

  const setValue = (value) => {
    setParams(urls.setParam(params, param, value));
  };

  return [ value, setValue ];
};

const useTarget = () => {

  const DEFAULT = '/campaigns';

  const [ target, setTarget ] = useParam('target');

  return {
    target: (target || DEFAULT),
    setTarget,
  };
};

const Redirect = ({ target }) => {

  const navigate = useNavigate();

  useEffect(() => {

    navigate(target);

  }, [navigate, target]);

  return <></>;
};

const Alias = ({ target }) => {

  const navigate = useNavigate();
  const [ params ] = useSearchParams();

  useEffect(() => {

    navigate(`${target}?${params.toString()}`);

  }, [navigate, target, params]);

  return <></>;
};

const urls = {
  setParam,
  useParam,

  useTarget,

  Redirect,
  Alias,
};

export default urls;